export const TERM_KEYS = [
    'project', 'section', 'task', 'goal', 'goal_tree', 'indicator', 'portfolio', 'external_collaborator', 'deliverable',
    'activity_report', 'corrective_plan', 'finding', 'corrective_action', 'risk', 'meeting', 'commitment', 'auditor',
    'team', 'workspace', 'supervisor',
];
export const DEFAULT_TERMS = {
    project: { one: 'Proyecto', many: 'Proyectos', gender: 'm' },
    section: { one: 'Sección', many: 'Secciones', gender: 'f' },
    task: { one: 'Tarea', many: 'Tareas', gender: 'f' },
    goal: { one: 'Objetivo', many: 'Objetivos', gender: 'm' },
    goal_tree: { one: 'Plan de objetivos', many: 'Planes de objetivos', gender: 'm' },
    indicator: { one: 'Indicador', many: 'Indicadores', gender: 'm' },
    portfolio: { one: 'Portafolio', many: 'Portafolios', gender: 'm' },
    external_collaborator: { one: 'Colaborador externo', many: 'Colaboradores externos', gender: 'm' },
    deliverable: { one: 'Entregable', many: 'Entregables', gender: 'm' },
    activity_report: { one: 'Informe de actividades', many: 'Informes de actividades', gender: 'm' },
    corrective_plan: { one: 'Plan de acciones correctivas', many: 'Planes de acciones correctivas', gender: 'm' },
    finding: { one: 'Hallazgo', many: 'Hallazgos', gender: 'm' },
    corrective_action: { one: 'Acción correctiva', many: 'Acciones correctivas', gender: 'f' },
    risk: { one: 'Riesgo', many: 'Riesgos', gender: 'm' },
    meeting: { one: 'Reunión', many: 'Reuniones', gender: 'f' },
    commitment: { one: 'Compromiso', many: 'Compromisos', gender: 'm' },
    auditor: { one: 'Auditor', many: 'Auditores', gender: 'm' },
    team: { one: 'Equipo', many: 'Equipos', gender: 'm' },
    workspace: { one: 'Espacio', many: 'Espacios', gender: 'm' },
    supervisor: { one: 'Responsable', many: 'Responsables', gender: 'm' },
};
/** Aplica, en orden, los términos de los paquetes activos y los del admin sobre los del núcleo. */
export function resolveTerms(...layers) {
    return Object.assign({}, DEFAULT_TERMS, ...layers.filter(Boolean));
}
/** «nuevo proyecto», «nueva tarea». */
export function newLabel(t) {
    return `${t.gender === 'f' ? 'Nueva' : 'Nuevo'} ${t.one.charAt(0).toLowerCase()}${t.one.slice(1)}`;
}
//# sourceMappingURL=terms.js.map